import i18n from '@src/plugins/i18n';
import {translateDb, i18nConfig, languages, translate} from '@i18n';
import {firestore} from '@src/db';


// Isso possibilita chamar a fcmGlobal a partir de funções sem contexto
const ctx = {
  /**
   * @type Promise<void>
   */
  startedPromise: undefined,
  started: false,
  _resolve: undefined,
  vueApp: undefined,

  dateFormat: (d, format='format.date') => {
    if (!d) {
      return '';
    }
    if (format.includes('format')) {
      format = i18n.t(format);
    }
    let _d = null;
    if (d instanceof moment) {
      _d = d;
    }
    else if (typeof d?.toDate === 'function') {
      _d = moment(d.toDate());
    }
    else {
      _d = moment(d);
    }
    if (_d.isValid()) {
      return _d.format(format);
    }
    return '';
  },
};


ctx.startedPromise = new Promise((resolve)=>{
  ctx._resolve = resolve;
});


export const fcmGlobal = {
  i18n: i18n,
  languages: languages,
  translateDb: translateDb,
  translate: translate,
  trDb: (obj) => {
    if(i18n?.locale) {
      const t = translateDb(i18n.locale, obj);
      if(t) {
        return t;
      }
    }
    return translateDb(i18nConfig.fallbackLocale, obj);
  },
  tr: (obj)=>{
    if(i18n?.locale) {
      const t = translate(i18n.locale, obj);
      if(t) {
        return t;
      }
    }
    return translate(i18nConfig.fallbackLocale, obj);
  },
  t: (...args) => {
    return i18n.t(...args);
  },

  newId: (...args) => {
    return firestore.collection('newId').doc().id;
  },

  showMsg: (...args) => {
    return ctx.vueApp.$showMsg(...args);
  },
  showWarning: (...args) => {
    return ctx.vueApp.$showWarning(...args);
  },
  showSuccess: (...args) => {
    return ctx.vueApp.$showSuccess(...args);
  },
  showError: (...args) => {
    return ctx.vueApp.$showError(...args);
  },
  showConfirm: (...args) => {
    return ctx.vueApp.$showConfirm(...args);
  },
  showSwal: (...args) => {
    return ctx.vueApp.$swal(...args);
  },
  newSequence: (id, table='', field='', extra=null) => {
    return ctx.vueApp.$newSequence(id, table, field, extra);
  },
  newSequenceMulti: (...args) => {
    return ctx.vueApp.$newSequenceMulti(...args);
  },
  metaInfo: (...args) => {
    return ctx.vueApp.$metaInfo(...args);
  },
  fcmGetDark: (...args) => {
    return ctx.vueApp.$fcmGetDark(...args);
  },
  fcmSetDark: (...args) => {
    return ctx.vueApp.$fcmSetDark(...args);
  },
  dateFormat: ctx.dateFormat,
  dateFormatBind(format= 'format.date') {
    return (d) => {
      return ctx.dateFormat(d, format);
    };
  },
  getCurrentCompany: (...args) => {
    return ctx.vueApp.currentCompany;
  },
};



export function initFcmGlobal(vueInstance) {
  if (ctx.started) {
    return;
  }
  ctx.vueApp = vueInstance;

  ctx._resolve();
  ctx.started = true;
}


